<template> 
    <div> 
      <div class="ms-4">
          <div class="page-title flex-row me-3"> 
              <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('general_offerorder_report') }} ({{ $t('stock') }})
              </h1> 
              <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                  <li class="breadcrumb-item text-gray-600">
                      <a href="#" class="text-gray-600 text-hover-primary">
                          <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                      </a>
                  </li> 
                  <li class="breadcrumb-item text-primary">{{ $t('reports') }}</li> 
                  <li class="breadcrumb-item text-primary">{{ $t('offerorder_reports') }}</li>    
                  <li class="breadcrumb-item text-gray-600">{{ $t('general_offerorder_report') }} ({{ $t('stock') }})
                      <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon> 
                  </li> 
              </ul> 
          </div>  
      </div>
      <div class="content flex-row-fluid mt-4" id="kt_content">      
          <div class="card">
              <div class="row fv-row border-0 pt-6 px-9">
                  <div class="col-lg-10">
                      <div class="fv-row mb-4 row">  
                          <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                              <label class="fw-bold form-label mt-3">
                                  <span>{{ $t('report_type') }}</span>
                              </label>
                              <Select2 v-model="form.report_type" :options="reportTypes"  :settings="{ width: '100%' }"/>
                          </div>                        
                          <div class="col-lg col-md-4 col-sm-6 col-xs-12" v-if="form.report_type == '2'">
                              <label class="fw-bold form-label mt-3">
                                  <span>{{ $t('start_date') }}</span>
                              </label>
                              <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                          </div>
                          <div class="col-lg col-md-4 col-sm-6 col-xs-12" v-if="form.report_type == '2'">
                              <label class="fw-bold form-label mt-3">
                                  <span>{{ $t('end_date') }}</span>
                              </label>
                              <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                          </div>
                          <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                              <label class="fw-bold form-label mt-3">
                                  <span>{{ $t('account') }}</span>
                              </label>
                              <Select2 v-model="form.account_id" :options="accountList"  :settings="{ width: '100%' }"/>
                          </div>
                          <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                              <label class="fw-bold form-label mt-3">
                                  <span>{{ $t('offerorder_type') }}</span>
                              </label>
                              <Select2 v-model="form.offer_type" :options="offerTypeList" :settings="{ width: '100%' }"/>
                          </div>
                          <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                              <label class="fw-bold form-label mt-3">
                                  <span>{{ $t('sales_vendor') }}</span>
                              </label>
                              <Select2 v-model="form.vendor_id" :options="salesVendorList"  :settings="{ width: '100%' }"/>
                          </div>
                          <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                              <label class="fw-bold form-label mt-3">
                                  <span>{{ $t('offerorder_status') }}</span>
                              </label>
                              <Select2 v-model="form.offer_status" :options="offerStatusList" :settings="{ width: '100%' }"/>
                          </div>
                      </div>  
                  </div>
                  <div class="col-lg-2">
                      <div class="d-flex justify-content-end my-6" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(72,'R')"> 
                          <Popper hover placement="top">
                              <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                  <i class="bi bi-eraser-fill fs-4"> </i>
                              </button>
                              <template #content>
                                  <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                              </template>
                          </Popper> 
                          <button type="button" class="btn btn-light-primary border border-primary"  data-kt-indicator="on" @click="getListData()">
                              <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                              <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                              <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                              </svg>
                              </span>
                              <span v-if="!this.isListProgressing"> {{ $t('list') }} </span> 
                              <span class="indicator-progress" v-if="this.isListProgressing">
                                  {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                              </span> 
                          </button> 
                      </div>
                      <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                          <div class="fw-bolder me-5">
                          <span class="me-2" data-kt-customer-table-select="selected_count"></span>{{ $t('selected') }}</div>
                          <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">{{ $t('delete_selected') }}</button>
                      </div>
                  </div>
              </div>
              <div class="card-body pt-3">
                  <div class="separator my-3 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                  <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                      <div class="table-responsive min-h-300px">
                          <ListOptions :expandedRowDetail="expandedRowDetail" :expandedView="true" @toggle-expand="toggleExpanded" :name="this.$options.name" ref="listOptionComponent"></ListOptions> 
                           <DxDataGrid id="gridContainer"
                                :key="$i18n.locale"
                                :show-borders="true"
                                key-expr="id"
                                :data-source="lists"
                                :allow-column-reordering="true" 
                                :allow-column-resizing="true"
                                :column-auto-width="true"
                                :row-alternatin-enabled="true"
                                :hover-state-enabled="true" 
                                :show-row-lines="true" 
                                :expandedRowKeys="expandedRowKeys" 
                                :ref="'dataGrid'"
                                :remote-operations="false"
                                @exporting="this.$onExporting($event , 'General Stock Offer/Order List')"
                                @row-expanding="onRowExpanding">   

                                <DxSummary :calculate-custom-summary="setDetailSummariesMaster">
                                    <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="offer_date"/>
                                    <DxTotalItem name="offer_quantity" summary-type="custom" show-in-column="offer_quantity" display-format="{0}" />
                                    <DxTotalItem name="offer_amount" summary-type="custom" show-in-column="offer_amount" display-format="{0}" />
                                    <DxTotalItem name="order_amount" summary-type="custom" show-in-column="order_amount" display-format="{0}" />
                                    <DxTotalItem name="order_quantity" summary-type="custom" show-in-column="order_quantity" display-format="{0}" />
                                    <DxTotalItem name="offer_and_order_quantity" summary-type="custom" show-in-column="offer_and_order_quantity" display-format="{0}" />
                                    <DxTotalItem name="offer_and_order_amount" summary-type="custom" show-in-column="offer_and_order_amount" display-format="{0}" />
                                    <DxTotalItem name="order_by_estimated_quantity" summary-type="custom" show-in-column="order_by_estimated_quantity" display-format="{0}" />
                                    <DxTotalItem name="estimated_quantity" summary-type="custom" show-in-column="estimated_quantity" display-format="{0}" />
                                    <DxTotalItem name="needed_quantity" summary-type="custom" show-in-column="needed_quantity" display-format="{0}" />
                                    <DxGroupItem :show-in-group-footer="true" name="offer_quantity" summary-type="custom" show-in-column="offer_quantity" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="offer_amount" summary-type="custom" show-in-column="offer_amount" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="order_quantity" summary-type="custom" show-in-column="order_quantity" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="order_amount" summary-type="custom" show-in-column="order_amount" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="offer_and_order_quantity" summary-type="custom" show-in-column="offer_and_order_quantity" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="offer_and_order_amount" summary-type="custom" show-in-column="offer_and_order_amount" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="order_by_estimated_quantity" summary-type="custom" show-in-column="order_by_estimated_quantity" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="estimated_quantity" summary-type="custom" show-in-column="estimated_quantity" display-format="{0}"/> 
                                    <DxGroupItem :show-in-group-footer="true" name="needed_quantity" summary-type="custom" show-in-column="needed_quantity" display-format="{0}"/> 
                                </DxSummary>

                                <DxFilterRow :visible="true"/>
                                <DxHeaderFilter :visible="true"/>
                                <DxGroupPanel :visible="true"/>      
                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                <DxPaging :page-size="pageSize"/>
                                <DxPager :visible="false" :allowed-page-sizes="pageSizesLists" :show-page-size-selector="showPageSizeSelectorLists" :show-info="true" :show-navigation-buttons="true"/>    
                                <DxSearchPanel :visible="true"/>
                                <DxScrolling
                                    mode="virtual"
                                    row-rendering-mode="virtual"
                                />
                                <DxColumn data-field="product_code" :caption="$t('product_code')" header-cell-template="product_code-header"/>    
                                <DxColumn data-field="stock_name" :caption="$t('account')" cell-template="stock_name-cell-template"/>    
                                <DxColumn data-field="current_quantity" :sorting-method="this.$numericSort" :caption="$t('current_qty')" header-cell-template="current-qty-header"  alignment="right"/>
                                <DxColumn data-field="current_amount" :sorting-method="this.$numericSort" :caption="$t('current_amount')" header-cell-template="current-amount-header" alignment="right"/>
                                <DxColumn cssClass="bg-light-teal" data-field="order_quantity" :sorting-method="this.$numericSort" :caption="$t('order_qty')" header-cell-template="order-qty-header" alignment="right"/>
                                <DxColumn cssClass="bg-light-teal" data-field="order_amount" :sorting-method="this.$numericSort" :caption="$t('order_amount')" header-cell-template="order-amount-header" alignment="right"/>
                                <DxColumn cssClass="bg-light-blue-grey" data-field="offer_quantity" :sorting-method="this.$numericSort" :caption="$t('offer_qty')" header-cell-template="offer-qty-header" alignment="right"/>
                                <DxColumn cssClass="bg-light-blue-grey" data-field="offer_amount" :sorting-method="this.$numericSort" :caption="$t('offer_amount')" header-cell-template="offer-amount-header" alignment="right"/>
                                <DxColumn cssClass="bg-light-indigo" data-field="offer_and_order_quantity" :sorting-method="this.$numericSort" :caption="$t('offer_order_quantity')" header-cell-template="offer_and_order_quantity-header" alignment="right"/>
                                <DxColumn cssClass="bg-light-indigo" data-field="offer_and_order_amount" :sorting-method="this.$numericSort" :caption="$t('offer_order_amount')" header-cell-template="offer_and_order_amount-header" alignment="right"/>
                                
                                <DxColumn cssClass="bg-light-brown" data-field="order_by_estimated_quantity" :sorting-method="this.$numericSort" :caption="$t('order_by_estimated_qty')" header-cell-template="estimated-by-order-qty-header"  alignment="right"/>
                                <DxColumn cssClass="bg-light-brown" data-field="estimated_quantity" :sorting-method="this.$numericSort" :caption="$t('estimated_qty')" header-cell-template="estimated-qty-header"  alignment="right"/>
                                <DxColumn data-field="critical_stock_quantity" :sorting-method="this.$numericSort" :caption="$t('critical_stock_qty')" header-cell-template="critical_stock_quantity-header" alignment="right"/>
                                <DxColumn data-field="needed_quantity" :sorting-method="this.$numericSort" :caption="$t('needed_qty')" header-cell-template="needed-qty-header" alignment="right"/>
                                
                                <template #product_code-header>
                                    <div>{{ $t('product_code') }}</div>
                                </template>
                                <template #current-qty-header>
                                    <div>{{ $t('current_quantity') }}</div>
                                </template>
                                <template #current-amount-header>
                                    <div>{{ $t('current_amount') }}</div>
                                </template>
                                <template #offer-qty-header>
                                    <div>{{ $t('offer_quantity') }}</div>
                                </template>
                                <template #offer-amount-header>
                                    <div>{{ $t('offer_amount') }}</div>
                                </template>
                                <template #order-amount-header>
                                    <div>{{ $t('order_amount') }}</div>
                                </template>
                                <template #order-qty-header>
                                    <div>{{ $t('order_quantity') }}</div>
                                </template>
                                <template #estimated-qty-header>
                                    <div>{{ $t('total_estimated_quantity') }}</div>
                                </template>
                                <template #estimated-by-order-qty-header>
                                    <div>{{ $t('order_by_estimated_qty') }}</div>
                                </template>
                                <template #needed-qty-header>
                                    <div>{{ $t('needed_quantity') }}</div>
                                </template>
                                <template #critical_stock_quantity-header>
                                    <div>{{ $t('critical_stock_qty') }}</div>
                                </template>
                                <template #offer_and_order_quantity-header>
                                    <div>{{ $t('offer_order_quantity') }}</div>
                                </template>
                                <template #offer_and_order_amount-header>
                                    <div>{{ $t('offer_order_amount') }}</div>
                                </template>
                                
                                <template #stock_name-cell-template="{ data }"> 
                                    <span class="text-gray-900"> 
                                        {{ data.data.stock_name }} 
                                    </span> 
                                    <small v-if="data.data.is_bundle_product == 1" class="ms-2 badge badge-sm badge-success">{{$t('bundle')}}</small>
                                </template>
  
                                <DxMasterDetail
                                    :enabled="true"
                                    :autoExpandAll="this.expandedRowDetail.autoExpandAll"
                                    template="masterDetailTemplate"
                                />
                                  
                                <template #masterDetailTemplate = "{ data }"  > 
                                    <DxDataGrid :data-source="data.data.detailList" :key="$i18n.locale" :show-borders="true" :column-auto-width="true" >
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="offer_date" :caption="$t('offerorder_date')" data-type="date" alignment="right" format="dd.MM.yyyy"/> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="offer_no" :caption="$t('offerorder_no')" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="account_name" :caption="$t('account')" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="position_name" :caption="$t('position')" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="quantity1" :caption="$t('quantity')" alignment="right" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="unit_name" :caption="$t('unit')" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="stock_currency" :caption="$t('currency')" alignment="left" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="price" :sorting-method="this.$numericSort" :caption="$t('price')" alignment="right" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="total_price" :sorting-method="this.$numericSort" :caption="$t('total')" alignment="right" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="discount_amount" :sorting-method="this.$numericSort" :caption="$t('discount')" alignment="right" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="net_price" :sorting-method="this.$numericSort" :caption="$t('net_total')" alignment="right" header-cell-template="net-total-header"/> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="tax_amount" :sorting-method="this.$numericSort" :caption="$t('vat_amount')" alignment="right" header-cell-template="vat-amount-header" /> 
                                        <DxColumn cssClass="bg-light-blue-grey" data-field="gross_amount" :sorting-method="this.$numericSort" :caption="$t('grand_total')" alignment="right" header-cell-template="grand-total-header" />
                                        
                                        <!-- Header template -->
                                        <template #net-total-header>
                                            <div>{{ $t('net_total') }}</div>
                                        </template> 
                                        <template #grand-total-header>
                                            <div>{{ $t('grand_total') }}</div>
                                        </template>
                                        <template #vat-amount-header>
                                            <div>{{ $t('vat_amount') }}</div>
                                        </template> 
                                        <!-- Cell template -->
                                        <template #tax_rate-cell-template="{ data }">
                                            <span class="p-3 align-middle text-gray-600 text-end" v-if="data.data.vat_status_id == 1">None</span>
                                            <span class="p-3 align-middle text-gray-600 text-end" v-else>{{data.data.tax_rate }}</span>
                                        </template>
                                
                                        <DxSummary :calculate-custom-summary="setDetailSummariesMasterDetail">
                                            <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="stock_account_code"/>
                                            <DxTotalItem name="gross_amount" summary-type="custom" show-in-column="gross_amount" display-format="{0}" />
                                            <DxTotalItem name="gross_amount_local" summary-type="custom" show-in-column="gross_amount_local" display-format="{0}" />
                                            <DxTotalItem name="tax_amount" summary-type="custom" show-in-column="tax_amount" display-format="{0}" />
                                            <DxTotalItem name="tax_amount_local" summary-type="custom" show-in-column="tax_amount_local" display-format="{0}" />
                                            <DxTotalItem name="net_price" summary-type="custom" show-in-column="net_price" display-format="{0}" />
                                            <DxTotalItem name="net_price_local" summary-type="custom" show-in-column="net_price_local" display-format="{0}" />
                                            <DxTotalItem name="discount_amount" summary-type="custom" show-in-column="discount_amount" display-format="{0}" />
                                            <DxTotalItem name="discount_amount_local" summary-type="custom" show-in-column="discount_amount_local" display-format="{0}" />
                                            <DxTotalItem name="total_price" summary-type="custom" show-in-column="total_price" display-format="{0}" />
                                            <DxTotalItem name="total_price_local" summary-type="custom" show-in-column="total_price_local" display-format="{0}" />
                                        </DxSummary>
                                    </DxDataGrid>
                                </template>
                                <DxStateStoring
                                    :enabled="true"
                                    type="custom"
                                    :storage-key="this.storageKey"
                                    :ref="dataGrid" 
                                    :saving-timeout="1000"
                                    :custom-load="LoadDXState"
                                /> 
                          </DxDataGrid>     
                      </div>  
                  </div> 
              </div>
          </div> 
      </div>
    </div>  
</template>
<script>
  import axios from 'axios' 
  
  import moment from 'moment'; 
  import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxSummary, DxTotalItem, DxScrolling, DxMasterDetail, DxGroupItem } from 'devextreme-vue/data-grid';
  export default {
    name: "GeneralStockOfferReport",
    components:{
      DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel,  DxStateStoring, DxSummary, DxTotalItem, DxScrolling, DxMasterDetail, DxGroupItem
    }, 
    data() {
      return {
          storageKey: 'dx_' + this.$options.name,
          pageSize: 100,
          pageSizeDetailList: 10,
          page_size: 20,
          lists: [],
          form:  {
              report_type: '1',
              start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
              end_date: moment(),
              offer_type: 0,
              position: 0,
              account_id: '-1',
              vendor_id: '-1',
              offer_status: -1
          },
          isListProgressing: false,
          isFilterOpen: false,
          offerTypeList: [{ id: 0, text: this.$t('all')}, { id: 1, text: this.$t('sales_offer')}, { id: 2, text: this.$t('purchase_offer')}],
          reportTypes: [{ id: '1', text: this.$t('general')}, { id: '2', text: this.$t('date_range')}],
          offerStatusList: [{ id: -1, text: this.$t('all')}, { id: 0, text: this.$t('passive')}, { id: 1, text: this.$t('active')}],
          criticalStockOptionList: [{ id: 0, text: this.$t('exclude_critical_stock_quantity')}, { id: 1, text: this.$t('include_critical_stock_quantity')}],
          positionList: [
              { id: 0, text: this.$t('all')},
              { id: 1, text: this.$t('offer')},
              { id: 2, text: this.$t('order')},
              { id: 3, text: this.$t('to_delivery')},
              { id: 4, text: this.$t('cancel')},
              { id: 5, text: this.$t('delivered')},
              { id: 6, text: this.$t('activated')},
              { id: 7, text: this.$t('deactivated')},
          ],
          salesVendorList: [],
          menuSelection: '/GeneralOfferStockReportHelppage',
          iconView : false,
          accountList:[],
          masterSelected:null,
          expandedRowKeys: [],
          expandedRowDetail:{
            autoExpandAll : false,
            listControl : false
          }
          
      };
    },
    computed: {
     previewDate(){
        return (value)=>{
         if (value) {
            return moment(new Date(value)).format('DD.MM.YYYY')
          }
        }
      },
      showPageSizeSelectorLists() {
          return this.lists.length > this.pageSize;
      },
      pageSizesLists() {
          let arr = [];
          let x = 1;
          let loop = (this.lists.length / this.pageSize);
          for (let i = 1; i <= loop && i <= 5; i++) {
              arr.push(this.pageSize * x);
              x++;
          }
          if(loop > 5) arr.push(1000);
          if(loop > 1) arr.push('all');
          return arr;
      },
      dxGrid() {
          return this.$refs["dataGrid"].instance;
      },
    },
    methods: {
      getListData() {
          this.$Progress.start();
          this.isListProgressing = true;
          this.form.start_date = (this.form.start_date == null || this.form.start_date == '') ? moment() : this.form.start_date;
          this.form.end_date = ( this.form.end_date == null || this.form.end_date == '') ? moment () : this.form.end_date; 
          const params = {
              session_id: this.$getUser().session_id,
              start_date: moment(this.form.start_date).format('YYYY-MM-DD[T]HH:mm:ss'),
              end_date: moment(this.form.end_date).format('YYYY-MM-DD[T]HH:mm:ss'),
              report_type: this.form.report_type,
              offer_type: this.form.offer_type,
              position: this.form.position,
              account_id: this.form.account_id == '-1' ? null : this.form.account_id,
              vendor_id: this.form.vendor_id == '-1' ? null : this.form.vendor_id,
              offer_status: this.form.offer_status
          };
          axios.post('/api/OfferReports/GeneralOfferStockReport', params, {'Content-Type': 'application/json'})
          .then((response) => {
              this.lists = !response.data.error ? response.data : [];
              this.expandedRowDetail.listControl = this.lists.length > 0 ? true : false;
              this.$refs["dataGrid"].instance.collapseAll(-1);
              this.$Progress.finish();
              setTimeout(() => {
                  this.isListProgressing = false;
              }, 500);
          })
          .catch((error) => {
              console.error(error);
               this.$Progress.finish();
               setTimeout(() => {
                   this.isListProgressing = false;
               }, 500);
          });
      },
      /** DX STATE OPERATIONS **/  
      LoadDXState() {
          return JSON.parse(sessionStorage.getItem(this.storageKey));
      }, 
      async helpPageViewIcon()
      {
          const queryparameter = {
              session_id : this.$getUser().session_id,
              menu_selection : '/GeneralOfferStockReportHelppage'
          };
          axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
          .then((response) => { 
              if(!response.data.error){ 
                  this.iconView = response.data;
              }
          })
      }, 
      setDetailSummariesMaster(options){  
          const optionNames = ["offer_amount", "offer_quantity", "order_amount", "order_quantity", "offer_and_order_quantity", "offer_and_order_amount", "order_by_estimated_quantity", "estimated_quantity", "needed_quantity"]; 
          optionNames.forEach(item => {
              if(options.name == item){
                  if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                  else if(options.summaryProcess === 'calculate'){
                      var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                      (options.totalValue += itemValue);
                  }
                  else if(options.summaryProcess === 'finalize'){ 
                      options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                  }
              }
          });
      },
      setDetailSummariesMasterDetail(options){  
          const optionNames = ["gross_amount", "gross_amount_local", "tax_amount", "tax_amount_local", "net_price", "net_price_local", "discount_amount", "discount_amount_local", "total_price", "total_price_local"]; 
          optionNames.forEach(item => {
              if(options.name == item){
                  if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                  else if(options.summaryProcess === 'calculate'){
                      var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                      (options.totalValue += itemValue);
                  }
                  else if(options.summaryProcess === 'finalize'){ 
                      options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                  }
              }
          });
      },
      setCriteriasToDefault() {   
          this.form = {
              report_type: '1',
              start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
              end_date: moment(),
              offer_type: 0,
              position: 0,
              account_id: '-1',
              vendor_id: '-1',
              offer_status: -1
          };
          this.lists = [];
      },
      getAccounts(){
        const parameters ={
            session_id: this.$getUser().session_id,
            account_type: 7 //Stock
        };
        const parametersTwo = {
            session_id: this.$getUser().session_id,
            supplier_account_type: 3, //Sales Vendors
        };  
        const requestOne =  axios.post('/api/CompanyAccounts/GetAccounts', parameters, {'Content-Type': 'application/json'});
        const requestTwo =  axios.post('/api/GetCompanyAccounts/GetPolicyAccounts', parametersTwo, {'Content-Type': 'application/json'});        
        axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
            this.accountList = responses[0].data.account_data;
            this.accountList.forEach(element => {
                element.name = this.$unlock(element.name);
                element.account_id = this.$unlock(element.account_id);
                element.text = this.$unlock(element.text);
            });
            this.accountList.unshift({ id: '-1', text: this.$t('all') });
            this.salesVendorList = responses[1].data;
            this.salesVendorList.unshift({ id: '-1', text: this.$t('all') });
        }))
        .catch(errors => { 
            console.error(errors); 
        }); 
      },
      async onRowExpanding(e) {
          const rowId = e.key;
          const params = {
              session_id: this.$getUser().session_id,
              stock_account_id: rowId,
              start_date: moment(this.form.start_date).format('YYYY-MM-DD[T]HH:mm:ss'),
              end_date: moment(this.form.end_date).format('YYYY-MM-DD[T]HH:mm:ss'),
              report_type: this.form.report_type,
              offer_type: this.form.offer_type,
              vendor_id: this.form.vendor_id == '-1' ? null : this.form.vendor_id,
              offer_status: this.form.offer_status,
          };
          axios.post('/api/OfferReports/GeneralOfferStockReportDetail', params, { 'Content-Type': 'application/json' })
          .then((response) => {
              if (response.data.error == null || response.data.error == 'undefined' || response.data.error == '') {
                  const dataSource = this.dxGrid.getDataSource();
                  this.lists.forEach(element => {
                      if(element.id == rowId) {
                          element.detailList = response.data;
                      }
                      this.expandedRowKeys = element.id
                  });
                  dataSource.reload();
              }
          })
          .catch(function(error){
              console.error(error);
          });
      },
      toggleExpanded() {
        this.expandedRowDetail.autoExpandAll = !this.expandedRowDetail.autoExpandAll;
        this.expandedRowDetail.autoExpandAll == true ? this.expandedControl(1) : this.expandedControl() 
      },
      expandedControl(value) {
            if (value == 1) {
            this.expandedRowKeys = this.lists.map(item => item.id); 
                Promise.all(this.lists.map(item => this.onRowExpanding({ key: item.id })))
                    .then(() => {
                        this.expandedRowKeys = [...this.expandedRowKeys]; 
                        this.$nextTick(() => {
                            this.expandedRowDetail.autoExpandAll = true;
                            this.dxGrid.repaint();
                        });
                    })
                    .catch(error => {
                        console.error( error);
                    });
            }else{
                this.expandedRowKeys = [];
                this.$nextTick(() => {
                    this.expandedRowDetail.autoExpandAll = false;
                    this.dxGrid.repaint();
                });
            }
        }
    },
    created() {
      this.helpPageViewIcon();
      this.getAccounts();
  
    },
  }; 
  </script>